import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PicksProvider } from "@/context/PicksContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Marquee from "@/components/Marquee";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Sell from "@/pages/Sell";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderSuccess from "@/pages/OrderSuccess";
import VIP from "@/pages/VIP";
import ReturnPolicy from "@/pages/ReturnPolicy";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import InfluencerPicks from "@/pages/InfluencerPicks";
import SellerProfile from "@/pages/SellerProfile";
import CreatorPage from "@/pages/CreatorPage";
import WeLove from "@/pages/WeLove";
import Advertise from "@/pages/Advertise";
import Join from "@/pages/Join";
import Blog from "@/pages/Blog";

import BlogPost from "@/pages/BlogPost";
import CleanGuide from "@/pages/CleanGuide";
import PartnerWelcome from "@/components/PartnerWelcome";
import ChatWidget from "@/components/ChatWidget";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <BrowserRouter>
        <AuthProvider>
          <PicksProvider>
          <Header />
          <PartnerWelcome />
          <Marquee />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/picks" element={<InfluencerPicks />} />
              <Route path="/creator/:code" element={<CreatorPage />} />
              <Route path="/seller/:id" element={<SellerProfile />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/sell" element={<Sell />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/vip" element={<VIP />} />
              <Route path="/returns" element={<ReturnPolicy />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/we-love" element={<WeLove />} />
              <Route path="/advertise" element={<Advertise />} />
              <Route path="/join" element={<Join />} />
              <Route path="/rewards" element={<Navigate to="/vip" replace />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/clean-guide" element={<CleanGuide />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <InstallPrompt />
          <Toaster position="top-center" theme="dark" richColors />
          </PicksProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
